module.exports = __webpack_public_path__ + "img/left-geometry.e7d73f59.png";